/**
 * 电商类埋点仅保留「购物车优惠券」结果上报（apply / 失败 / remove），由 assets/cart.js
 * 在 cart/update 请求完成后调用 pageTracking.reportCommerceInteraction。
 * 其它购物流程由 Customer / Web Pixel 等处理，不再做文档级点击采集。
 */
(function (root, factory) {
  const createPageTrackingCommerceInteraction = factory();

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = createPageTrackingCommerceInteraction;
    return;
  }

  if (root) {
    root.createPageTrackingCommerceInteraction = createPageTrackingCommerceInteraction;
  }
})(typeof window !== 'undefined' ? window : undefined, function createPageTrackingCommerceInteractionFactory() {
  return function createPageTrackingCommerceInteraction(core, options) {
    const currentOptions = options || {};
    const pageIdentity = currentOptions.pageIdentity || {
      pageName: '',
      subPageName: '',
      pageId: ''
    };
    const actionTypeRequiredFields = {
      applyCoupon: ['actionType', 'couponCode'],
      removeCoupon: ['actionType', 'couponCode']
    };

    function getActionTypeRequiredFields(actionType) {
      return actionTypeRequiredFields[actionType] || null;
    }

    function resolveFirstPresentValue(values) {
      let index;

      for (index = 0; index < values.length; index += 1) {
        if (values[index] !== null && values[index] !== undefined && values[index] !== '') {
          return values[index];
        }
      }

      return '';
    }

    function normalizeCommerceProduct(product) {
      const currentProduct = product || {};
      const productId = resolveFirstPresentValue([
        currentProduct.productId,
        currentProduct.product_id,
        currentProduct.id,
        currentProduct.variant_id
      ]);
      const productName = resolveFirstPresentValue([
        currentProduct.productName,
        currentProduct.product_title,
        currentProduct.title,
        currentProduct.name
      ]);
      const productQty = resolveFirstPresentValue([
        currentProduct.productQty,
        currentProduct.quantity
      ]);
      const productPrice = resolveFirstPresentValue([
        currentProduct.productPrice,
        currentProduct.final_price,
        currentProduct.price,
        currentProduct.line_price
      ]);

      return {
        productName: core.utils.fillEmptyValue(productName),
        productPrice: core.utils.fillEmptyValue(productPrice),
        productId: core.utils.fillEmptyValue(productId),
        productQty: core.utils.fillEmptyValue(productQty)
      };
    }

    function resolveCommerceProducts(fields) {
      const currentFields = fields || {};
      const cartState = currentFields.cartState || currentFields.cart || {};
      const sourceProducts = Array.isArray(currentFields.products)
        ? currentFields.products
        : (Array.isArray(cartState.items) ? cartState.items : []);

      return sourceProducts
        .map(normalizeCommerceProduct)
        .filter(function hasProductIdentity(product) {
          return Boolean(product.productId || product.productName);
        });
    }

    function buildCommerceInteractionData(fields, now) {
      const currentFields = fields || {};
      const products = resolveCommerceProducts(currentFields);
      let dataInfo;

      dataInfo = core.buildDataInfo({
        type: core.config.eventTypes && core.config.eventTypes.commerceInteraction,
        pageName: pageIdentity.pageName,
        actionType: currentFields.actionType,
        products: products,
        couponCode: currentFields.couponCode,
        couponDiscount: currentFields.couponDiscount,
        couponStatus: currentFields.couponStatus,
        orderId: currentFields.orderId,
        orderTotal: currentFields.orderTotal,
        paymentMethod: currentFields.paymentMethod,
        paymentStatus: currentFields.paymentStatus,
        checkoutStep: currentFields.checkoutStep
      }, now);

      dataInfo.products = products;

      return dataInfo;
    }

    function findMissingRequiredFields(fields) {
      const actionType = core.utils.fillEmptyValue(fields && fields.actionType).trim();
      const requiredFields = getActionTypeRequiredFields(actionType);

      if (!requiredFields) {
        return ['actionType'];
      }

      return requiredFields.filter(function isMissing(fieldKey) {
        return !core.utils.fillEmptyValue(fields[fieldKey]).trim();
      });
    }

    function shouldUseBeacon(actionType) {
      return true;
    }

    function reportCommerceInteractionFields(fields, sessionModule, sessionCallbacks) {
      const nowMs = Date.now();
      let dataInfo;
      let missingFields;

      if (
        !core.canTrack() ||
        !core.config.eventTypes ||
        !core.config.eventTypes.commerceInteraction ||
        !fields
      ) {
        return false;
      }

      dataInfo = buildCommerceInteractionData(fields, new Date(nowMs));

      missingFields = findMissingRequiredFields(dataInfo);

      if (missingFields.length > 0) {
        return false;
      }

      if (sessionModule && typeof sessionModule.ensureActiveSession === 'function') {
        sessionModule.ensureActiveSession(nowMs, sessionCallbacks || {});
      }

      core.markActivity(nowMs);

      return core.sendTrackingEvent({
        basicInfo: core.buildBasicInfo(),
        dataInfo: dataInfo
      }, shouldUseBeacon(dataInfo.actionType));
    }

    return {
      actionTypeRequiredFields,
      getActionTypeRequiredFields,
      resolveFirstPresentValue,
      normalizeCommerceProduct,
      resolveCommerceProducts,
      buildCommerceInteractionData,
      findMissingRequiredFields,
      shouldUseBeacon,
      reportCommerceInteractionFields
    };
  };
});
